import {DownloadStrategy} from "../../type";

export class PrimaryDownloadStrategy implements DownloadStrategy {
    downloadUrl: string;
    constructor(private url: string) {
        this.downloadUrl = url;
    }

    async download(downloadFunc: (url: string) => any): Promise<Buffer> {
        try {
            return await downloadFunc(this.downloadUrl);
        } catch (error) {
            console.error('Primary download failed:', error);
            throw error; // 抛出错误以触发责任链的下一级
        }
    }
}

export class BackupDownloadStrategy implements DownloadStrategy {
    downloadUrl: string;
    constructor(private url: string) {
        this.downloadUrl = url;
    }

    async download(downloadFunc: (url: string) => any): Promise<Buffer> {
        try {
            return await downloadFunc(this.downloadUrl);
        } catch (error) {
            console.error('Backup download failed:', error);
            throw error;
        }
    }
}

export class Backup1DownloadStrategy implements DownloadStrategy {
    downloadUrl: string;
    constructor(private url: string) {
        this.downloadUrl = url;
    }

    async download(downloadFunc: (url: string) => any): Promise<Buffer> {
        try {
            return await downloadFunc(this.downloadUrl);
        } catch (error) {
            console.error('Backup1 download failed:', error);
            throw error;
        }
    }
}

export class DownloadContext {
    private strategies: DownloadStrategy[] = [];

    addStrategy(strategy: DownloadStrategy): void {
        this.strategies.push(strategy);
    }

    autoAddStrategy(url: string): void {
        this.strategies.push(new PrimaryDownloadStrategy(url));
        this.strategies.push(new BackupDownloadStrategy(url));
        this.strategies.push(new Backup1DownloadStrategy(url));
    }

    async executeDownload(downloadFunc: (url: string) => void, errorFunc: (error: any) => void): Promise<Buffer> {
        let e = null;
        for (const strategy of this.strategies) {
            try {
                return await strategy.download(downloadFunc); // 成功则返回
            } catch (error) {
                e = error;
                console.error('Model download error:', error);
                continue; // 失败则尝试下一个策略
            }
        }
        errorFunc(e);
        throw new Error('All model download strategies failed');
    }
}
